import { Directive, ElementRef, AfterViewInit, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

declare var $: any; // Declare $ for jQuery

@Directive({
  selector: '[appFloatThead]'
})
export class FloatTheadDirective implements OnChanges, AfterViewInit, OnDestroy {

    @Input() floatTableClassRef: string;
    @Input() floatTableRef: any;
    @Input() forceReflow: any;
    @Input() showFloatHeader: boolean = true;

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    private observer = new MutationObserver(() => this.resetFloatThead());

    constructor(private el: ElementRef) {}

    ngAfterViewInit() {
        this.setFloatThead();
        // this.registerListenerForDomChanges();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['showFloatHeader'] && changes['showFloatHeader']?.currentValue){
            this.setFloatThead();
        }

        if(changes['forceReflow'] && (changes['forceReflow']?.currentValue || changes['forceReflow']?.currentValue===false)){
            this.resetFloatThead();
        }
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    setFloatThead(){
        if(this.floatTableClassRef && this.showFloatHeader){
            const table = this.floatTableClassRef;
            const $tableRef = $(`.${table} .p-datatable-table`);
            const $tableRes = $(`.${table} .p-datatable-wrapper`);
            $tableRef.floatThead({
                top: 88,
                autoReflow: true,
                responsiveContainer: function($table){
                    return $tableRes;
                }
            });
        }

        if(this.floatTableRef){
            this.floatTableRef.onColResize.pipe(takeUntil(this.ngUnsubscribe$)).subscribe($event=>{
                this.resetFloatThead()
            })
        }
    }

    resetFloatThead(){
        if(this.floatTableClassRef){
            const table = this.floatTableClassRef;
            const $tableRef = $(`.${table} .p-datatable-table`);
            $tableRef.floatThead('reflow');
        }
    }

    private registerListenerForDomChanges() {
        const attributeFilter: string[] = ['style'];
		const attributes = true;
		const childList = true;
		const subtree = true;
		this.observer.observe(this.el.nativeElement, { attributeFilter, attributes, childList, subtree });
	}
}
